import {
  NestedQuota,
  QuotaPayload,
} from '../../../shared/interfaces/quota.interface';
import { SurveyNestedQuotas } from '../../domain/survey-nested-quotas';

export class NestedQuotasResetEvaluator {
  constructor(
    private readonly _surveyQuotas: QuotaPayload[],
    private readonly _selectedQualIds: number[],
    private readonly _actualNestedQuotas: NestedQuota[]
  ) {}

  public evaluate(): boolean {
    if (!this._surveyQuotas.length || !this._actualNestedQuotas.length) {
      return false;
    }

    return this._estimatedCount() !== this._actualCount();
  }

  private _estimatedCount(): number {
    return this._selectedQualIds.reduce(
      (count, selectedQualId) =>
        count * this._matchingQuotas(selectedQualId).length,
      1
    );
  }

  private _matchingQuotas(qualificationId: number): QuotaPayload[] {
    return this._surveyQuotas.filter(
      (quota) =>
        Number(quota.criteria[0].qualification_code) === qualificationId
    );
  }

  private _actualCount(): number {
    return new SurveyNestedQuotas(this._actualNestedQuotas).ungrouped().get()
      .length;
  }
}
